import TeamDeleteUser from "./team-delete-user";

export default TeamDeleteUser;